import { compose } from 'redux'

// higher-order components
import withAppSettings from 'components/shared/withAppSettings'

// presentational component
import UI from './UI'

export default compose(withAppSettings)(UI)
